export default "__VITE_ASSET__BVcQAkyG__"